import "features/cases/blocks/CommonCard/elements/AutosaveStatus/AutosaveStatus.css";
import React from "react";

export type AutosaveStatusValue =
  "idle" | "dirty" | "saving" | "saved" | "error" | "savedLocally";

const formatSavedAt = (date: Date): string =>
  date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });

const buildStatusText = (
  status: AutosaveStatusValue,
  lastSavedAt: Date | null,
): string => {
  const at = lastSavedAt ? ` в ${formatSavedAt(lastSavedAt)}` : "";

  switch (status) {
    case "saving":
      return "Сохраняется…";
    case "error":
      return lastSavedAt
        ? `Не удалось сохранить · последнее автосохранение${at}`
        : "Не удалось сохранить";
    case "savedLocally":
      return lastSavedAt ? `Черновик сохранён в этом браузере${at}` : "";
    case "dirty":
      return lastSavedAt ? `Есть несохранённые изменения · сохранено${at}` : "";
    case "saved":
    case "idle":
      return lastSavedAt ? `Сохранено${at}` : "";
    default:
      return "";
  }
};

const AutosaveStatus = ({
  status,
  lastSavedAt,
}: {
  status: AutosaveStatusValue;
  lastSavedAt: Date | null;
}) => {
  const text = buildStatusText(status, lastSavedAt);

  if (!text) return null;

  return (
    <span className={`autosave-status autosave-status--${status}`}>{text}</span>
  );
};

export default AutosaveStatus;
